import { StateAcronym } from "../state/state-acronym";

export class PractitionerRegistration {
  private registration: number = 0;
  private state: StateAcronym;

  setRegistration(value: number): void {
    this.registration = value;
  }

  getRegistration(): number {
    return this.registration;
  }

  setState(value: StateAcronym): void {
    this.state = value;
  }

  getState(): StateAcronym {
    return this.state;
  }
}
